import React, { useContext, useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { useNavigate, Form, Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { apiurl, host } from "../../path";
import {
  Adminimg,
  AdminLogo,
  login_side_img,
  Vadhavan,
  VadhavanLogin,
  AdminLogin1,
  Loginimg1,
  SingleUnifiedPortalLogo,
  VadhvanLogo256,
  Contact32,
  EmailS32,
  Time32,
  BankofMaharashtraLogo256,
  SoftmateSystemsLogo,
  Loginimg11,
  Username32,
  Password32,
  Loginimg123,
  UDDLOGO,
  LRMS1,
  SingleUnifiedSystemLogo1,
  SingleUnifiedPortalLogo1,
} from "../../public/LoginImages/importimages";
import "./admin.css";
import Application from "./StateContext/Application";
import { useLanguage } from "../../lang/langcontext/LanguageContext";

const AdminLogin = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const operation = useContext(Application);
  const { getcaptcha, validatecaptcha, Login, validateOtp } = operation;

  // --------------------------

  const [maskedPhone, setMaskedPhone] = useState("");
  const [resendTimer, setResendTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpUniqid, setOtpUniqid] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("Token");

    // User is on login page and not logged in
    // Always reset login page language to English
    if (!token && language !== "en") {
      toggleLanguage("en");
    }
  }, [language, toggleLanguage]);

  
  useEffect(() => {
    let interval;

    if (showOTP) {
      setResendTimer(60);
      setCanResend(false);

      interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [showOTP, otpUniqid]);

  // ----------------------

  const [form, setform] = useState({
    username: "",
    Password: "",
    captchaText: "",
  });

  const [unqid, setuniqid] = useState(false);

  // useEffect(() => { captchaManager() }, [])

  const captchaManager = async (e) => {
    const d = await getcaptcha();
    document.getElementById("captcha").innerHTML = d.captchad;
    setuniqid(d.id);
  };

  // --> old code without otp
  // const login = async () => {
  //   // console.log(form.username, form.Password, form.captchaText, unqid);

  //   // const isValid = await validatecaptcha(unqid, form.captchaText);
  //   // console.log("isvalid", isValid);

  //   // if (!isValid) {
  //   //   alert("Invalid captcha. Please try again.");
  //   //   setform({ ...form, captchaText: "" });
  //   //   captchaManager(); // refresh captcha
  //   //   return;
  //   // }

  //   try {
  //     const data = await Login({
  //       username: form.username,
  //       Password: form.Password,
  //     });
  //     console.log(data);

  //     if (data) {
  //       localStorage.setItem("Token", data);
  //       setCookie("userId", data, { path: "/" });
  //       window.location.href = "/AdminDashboard";
  //     } else {
  //       alert("Incorrect id or password");
  //     }
  //   } catch (error) {
  //     console.error("Error in AdminLogin:", error);
  //   }
  // };


  //--> OTP code
  const login = async () => {
    // console.log(form.username, form.Password, form.captchaText, unqid);

    // const isValid = await validatecaptcha(unqid, form.captchaText);
    // console.log("isvalid", isValid);

    // if (!isValid) {
    //   alert("Invalid captcha. Please try again.");
    //   setform({ ...form, captchaText: "" });
    //   captchaManager(); // refresh captcha
    //   return;
    // }

    try {
      const data = await Login({
        username: form.username,
        Password: form.Password,
      });
      console.log("Login data: ", data);

      if (data?.otpRequired) {
        setShowOTP(true);
        setOtpUniqid(data.uniqid);
        setMaskedPhone(data.phone);
      } else {
        alert("Invalid Username or Password");
      }
    } catch (error) {
      console.error("Error in AdminLogin:", error);
    }
  };

  const VerifyOTP = async () => {
    let data = await validateOtp(otp, otpUniqid);

    if (data.success) {
      localStorage.setItem("Token", data.token);

      setCookie("userId", data.token, { path: "/" });
      alert("Login successful!\n\nYour session will automatically expire after 15 minutes of inactivity.");

      window.location.href = "/AdminDashboard";
    } else {
      alert("Invalid OTP");
    }
  };

  const PasswordManager = (e) => {
    const input = document.getElementById("Password");
    const icon = e.target;

    if (input.type === "password") {
      input.type = "text";
      icon.classList.remove("fa-eye");
      icon.classList.add("fa-eye-slash");
    } else {
      input.type = "password";
      icon.classList.remove("fa-eye-slash");
      icon.classList.add("fa-eye");
    }
  };

  const isMobile = window.innerWidth <= 768;

  const resendOTP = async () => {
    if (!canResend) return;

    try {
      const data = await Login({
        username: form.username,
        Password: form.Password,
      });

      if (data?.otpRequired) {
        setOtpUniqid(data.uniqid);
        setOtp("");
        setResendTimer(60);
        setCanResend(false);
        setMaskedPhone(data.phone);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // return (
  //   <div style={{ height: 'auto' }}>
  //     <div style={{
  //       backgroundImage: `url(${Loginimg123})`, backgroundSize: "cover", backgroundPosition: "center", minHeight: '100vh', width: "100%", position: "relative",
  //     }}>
  //       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', padding: '6px 20px', }}>
  //         <div className='col-8'>
  //           <div className="row">
  //             <div>
  //               <img src={SingleUnifiedPortalLogo1} alt="Portal Logo" style={{ width: '20rem', height: 'auto' }} />
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '2rem', paddingTop: '2rem', justifyContent: 'center', paddingLeft: '5rem' }}>
  //         <div style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", borderRadius: "10px", boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)", color: "white", padding: "20px 30px 10px 30px", marginLeft: '2rem' }}>
  //           <div>
  //             <h4>Single Unified Portal प्रकल्पाच्या सुरक्षित वापरासाठी सूचना :</h4>
  //             <div style={{ padding: '0px 25px 0px 1px' }}>
  //               <p style={{ display: 'flex', fontSize: '15px', gap: '10px' }}>
  //                 <div>»</div><div>
  //                   Cyber Attack, Virus आणि Malware चे धोके कमी करण्यासाठी, सर्व<br /> वापरकर्त्यांना त्यांच्या System मधून (डेस्कटॉप / लॅपटॉप) पोर्टलमध्ये प्रवेश <br />करताना खालील सुरक्षा उपायांचे पालन करणे आवश्यक आहे.
  //                 </div>
  //               </p>
  //               <p style={{ display: 'flex', fontSize: '15px', gap: '10px' }}>
  //                 <div> »</div> <div> External storage चा वापर करताना काळजीपूर्वक करणे आवश्यक आहे.<br /> अनवधानाने त्यातून काही Virus आणि Malware संगणकावर येऊ शकतात त्यामुळे<br /> डेटा चोरीची शक्यता असते.</div>
  //               </p>
  //               <p style={{ display: 'flex', fontSize: '15px', gap: '10px' }}>
  //                 <div><p> »</p> </div><div> licensed अँटी वायरस Software चा वापर करा अँटी व्हायरस ऐप्लिकेशन<br /> योग्यरीत्या Install केले आहे आणि नियमितपणे अपडेट केले आहे याची खात्री करा.<br />
  //                   इतरही Authorized आणि licensed Software चाच वापर करा.</div>
  //               </p>
  //             </div>
  //           </div>

  //         </div>
  //         <div style={{
  //           backgroundColor: "rgba(255, 255, 255, 0.70)",
  //           borderRadius: "10px",
  //           boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)",
  //           maxWidth: "500px",
  //           margin: "0 auto",
  //           maxHeight: "90vh",
  //           overflowY: "auto"
  //         }}>
  //           <Form
  //             onSubmit={() => login()}
  //             className="login-form-container"
  //             style={{
  //               display: 'grid',
  //               justifyContent: 'center',
  //               padding: isMobile ? '0 10px' : '0',
  //               borderRadius: '10px',
  //               boxShadow: '2px 2px 6px 2px',

  //             }}
  //           >
  //             <h6
  //               className="form-header"
  //               style={{
  //                 display: 'flex',
  //                 justifyContent: 'center',
  //                 alignItems: 'center',
  //                 background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )',
  //                 height: '3rem',
  //                 borderRadius: '10px 10px 0px 0px',
  //                 padding: '8px',
  //                 color: 'white',
  //                 fontWeight: '700',
  //                 margin: 0
  //               }}
  //             >
  //               Single Unified Portal-SIGN IN
  //             </h6>
  //             <div
  //               className="card"
  //               style={{
  //                 backgroundColor: 'transparent',
  //                 border: "none",
  //                 padding: '20px',
  //                 borderRadius: '12px',
  //               }}
  //             >
  //               <div style={{ paddingBottom: '10px', position: 'relative' }}>
  //                 <i className='my-2' style={{ position: 'relative', backgroundColor: 'transparent', zIndex: 0, fontSize: '14px', display: 'block', marginBottom: '5px' }}>
  //                   <b>Username</b>
  //                 </i>
  //                 <div style={{ position: 'relative' }}>
  //                   <img
  //                     src={Username32}
  //                     alt="icon"
  //                     style={{
  //                       position: 'absolute',
  //                       top: '50%',
  //                       transform: 'translateY(-50%)',
  //                       left: '10px',
  //                       width: '20px',
  //                       height: '20px',
  //                     }}
  //                   />
  //                   <input style={{ border: 'none', borderRadius: '6px', height: '2.5rem', padding: '8px 8px 8px 40px', fontSize: '15px', fontWeight: '600', backgroundColor: '#f5f5f5', }} type="text" className="form-control" id="username" placeholder="Enter Username Here" onChange={(e) => setform({ ...form, [e.target.id]: e.target.value })} required maxLength={50} />
  //                 </div>
  //                 <div>
  //                   <i style={{ position: 'relative', backgroundColor: 'transparent', fontSize: '14px' }}>
  //                     <b>Password</b>
  //                   </i>
  //                   <div style={{ display: "flex", alignItems: 'center', position: 'relative' }}>
  //                     <img
  //                       src={Password32}
  //                       alt="lock"
  //                       style={{
  //                         position: "absolute",
  //                         left: "10px",
  //                         top: "50%",
  //                         transform: "translateY(-50%)",
  //                         width: "20px",
  //                         height: "20px",
  //                         pointerEvents: "none",
  //                         zIndex: 1
  //                       }}
  //                     />
  //                     <input className="form-control custom-password-input" style={{ display: 'flex', alignItems: 'center', height: '2.5rem', border: "none", borderRadius: "6px", backgroundColor: '#f5f5f5', outline: 'none', padding: '0px 30px 0px 40px' }} type='password' id="Password" placeholder='Enter Password Here' onChange={(e) => setform({ ...form, [e.target.id]: e.target.value })}
  //                       required maxLength={30} />
  //                     <i
  //                       style={{
  //                         position: "absolute",
  //                         right: "10px",
  //                         top: "50%",
  //                         transform: "translateY(-50%)",
  //                         cursor: "pointer",
  //                         zIndex: 1
  //                       }}
  //                       className="fa-regular fa-eye"
  //                       onClick={(e) => PasswordManager(e)}
  //                     />
  //                   </div>
  //                   <p className='mx-3 my-2' style={{ fontWeight: '700', fontSize: '13px' }}>
  //                     Note: Username and Password are Case Sensitive
  //                   </p>
  //                 </div>

  //                 {/* <div style={{ marginTop: '5px' }}>
  //                   <label htmlFor="captchaText" style={{ fontWeight: 'bold', fontSize: '14px' }}>Captcha</label>
  //                   <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
  //                     <div
  //                       id="captcha"
  //                       style={{
  //                         backgroundColor: '#e6e6e6',
  //                         padding: '8px',
  //                         borderRadius: '5px',
  //                         minWidth: '100px',
  //                         flex: 1
  //                       }}
  //                     ></div>
  //                     <i className="fa fa-refresh" style={{ cursor: 'pointer' }} onClick={captchaManager}></i>
  //                   </div>
  //                   <input
  //                     type="text"
  //                     id="captchaText"
  //                     value={form.captchaText}
  //                     onChange={(e) => setform({ ...form, captchaText: e.target.value })}
  //                     placeholder="Enter Captcha"
  //                     className="form-control mt-2"
  //                     style={{ height: '2.5rem', backgroundColor: '#f5f5f5', border: 'none', borderRadius: '6px', paddingLeft: '10px', fontWeight: '600' }} maxLength={6}
  //                     required
  //                   />
  //                 </div> */}

  //                 <div
  //                   className='my-3'
  //                   style={{
  //                     display: 'flex',
  //                     justifyContent: 'space-between',
  //                     alignItems: 'center',
  //                     gap: '1rem',
  //                     marginTop: '15px',
  //                     flexWrap: isMobile ? 'wrap' : 'nowrap'
  //                   }}
  //                 >
  //                   <a href="/ForgetPassword" style={{ background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'none', }}>Forgot Password?</a>
  //                   <div>
  //                     <button type='submit' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '7rem', height: '2.5rem', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', borderRadius: '11px', fontSize: '19px' }}>Login</button>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </Form>
  //         </div>
  //       </div>
  //       <footer className="footer-container" style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: 0, width: '100%', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', color: 'white', padding: '10px 20px', fontSize: '14px', alignItems: 'center' }}>
  //         <div className="footer-text">
  //           <p style={{ margin: '0px' }}>
  //             Contents on this website are owned, updated, and managed by the Rural Development Department, Government of Maharashtra.<br />
  //             Site is technically designed, hosted, and maintained by <strong style={{ color: '#fff700' }}> Bank of Maharashtra.</strong>
  //             Site is technically designed, hosted, and maintained by <strong style={{ color: '#fff700' }}> Bank of Maharashtra.</strong>
  //           </p>
  //         </div>
  //         <div className="footer-logo-container" style={{ display: 'flex', gap: '16px' }}>
  //           <img src={BankofMaharashtraLogo256} style={{ backgroundColor: 'white', height: 'auto' }} />
  //           {/* <img src={SoftmateSystemsLogo} style={{ width: '7.5rem', height: 'auto' }} /> */}
  //         </div>
  //       </footer>

  //     </div>
  //   </div>
  // )

  return (
    <div style={{ height: "auto" }}>
      <div
        style={{
          backgroundImage: `url(${Loginimg123})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          width: "100%",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
            padding: "6px 20px",
          }}
        >
          <div className="col-8">
            <div className="row">
              <div>
                <img
                  src={SingleUnifiedPortalLogo1}
                  alt="Portal Logo"
                  style={{ width: "20rem", height: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "2rem",
            paddingTop: "2rem",
            justifyContent: "center",
            paddingLeft: "5rem",
          }}
        >
          <div
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderRadius: "10px",
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
              color: "white",
              padding: "20px 30px 10px 30px",
              marginLeft: "2rem",
            }}
          >
            <div>
              <h4>
                Single Unified Portal प्रकल्पाच्या सुरक्षित वापरासाठी सूचना :
              </h4>
              <div style={{ padding: "0px 25px 0px 1px" }}>
                <p style={{ display: "flex", fontSize: "15px", gap: "10px" }}>
                  <div>»</div>
                  <div>
                    Cyber Attack, Virus आणि Malware चे धोके कमी करण्यासाठी, सर्व
                    <br /> वापरकर्त्यांना त्यांच्या System मधून (डेस्कटॉप /
                    लॅपटॉप) पोर्टलमध्ये प्रवेश <br />
                    करताना खालील सुरक्षा उपायांचे पालन करणे आवश्यक आहे.
                  </div>
                </p>
                <p style={{ display: "flex", fontSize: "15px", gap: "10px" }}>
                  <div> »</div>{" "}
                  <div>
                    {" "}
                    External storage चा वापर करताना काळजीपूर्वक करणे आवश्यक आहे.
                    <br /> अनवधानाने त्यातून काही Virus आणि Malware संगणकावर येऊ
                    शकतात त्यामुळे
                    <br /> डेटा चोरीची शक्यता असते.
                  </div>
                </p>
                <p style={{ display: "flex", fontSize: "15px", gap: "10px" }}>
                  <div>
                    <p> »</p>{" "}
                  </div>
                  <div>
                    {" "}
                    licensed अँटी वायरस Software चा वापर करा अँटी व्हायरस
                    ऐप्लिकेशन
                    <br /> योग्यरीत्या Install केले आहे आणि नियमितपणे अपडेट केले
                    आहे याची खात्री करा.
                    <br />
                    इतरही Authorized आणि licensed Software चाच वापर करा.
                  </div>
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.70)",
              borderRadius: "10px",
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)",
              maxWidth: "500px",
              margin: "0 auto",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <Form
              onSubmit={() => login()}
              className="login-form-container"
              style={{
                display: "grid",
                justifyContent: "center",
                padding: isMobile ? "0 10px" : "0",
                borderRadius: "10px",
                boxShadow: "2px 2px 6px 2px",
              }}
            >
              <h6
                className="form-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background:
                    "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                  height: "3rem",
                  borderRadius: "10px 10px 0px 0px",
                  padding: "8px",
                  color: "white",
                  fontWeight: "700",
                  margin: 0,
                }}
              >
                Single Unified Portal-SIGN IN
              </h6>
              <div
                className="card"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  padding: "20px",
                  borderRadius: "12px",
                }}
              >
                <div style={{ paddingBottom: "10px", position: "relative" }}>
                  <i
                    className="my-2"
                    style={{
                      position: "relative",
                      backgroundColor: "transparent",
                      zIndex: 0,
                      fontSize: "14px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    <b>{t("Username")}</b>
                  </i>
                  <div style={{ position: "relative" }}>
                    <img
                      src={Username32}
                      alt="icon"
                      style={{
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        left: "10px",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    <input
                      style={{
                        border: "none",
                        borderRadius: "6px",
                        height: "2.5rem",
                        padding: "8px 8px 8px 40px",
                        fontSize: "15px",
                        fontWeight: "600",
                        backgroundColor: "#f5f5f5",
                      }}
                      type="text"
                      className="form-control"
                      id="username"
                      placeholder="Enter Username Here"
                      onChange={(e) =>
                        setform({ ...form, [e.target.id]: e.target.value })
                      }
                      required
                      maxLength={60}
                    />
                  </div>
                  <div>
                    <i
                      style={{
                        position: "relative",
                        backgroundColor: "transparent",
                        fontSize: "14px",
                      }}
                    >
                      <b>{t("Password")}</b>
                    </i>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                      }}
                    >
                      <img
                        src={Password32}
                        alt="lock"
                        style={{
                          position: "absolute",
                          left: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: "20px",
                          height: "20px",
                          pointerEvents: "none",
                          zIndex: 1,
                        }}
                      />
                      <input
                        className="form-control custom-password-input"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          height: "2.5rem",
                          border: "none",
                          borderRadius: "6px",
                          backgroundColor: "#f5f5f5",
                          outline: "none",
                          padding: "0px 30px 0px 40px",
                        }}
                        type="password"
                        id="Password"
                        placeholder="Enter Password Here"
                        onChange={(e) =>
                          setform({ ...form, [e.target.id]: e.target.value })
                        }
                        required
                        maxLength={30}
                      />
                      <i
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          zIndex: 1,
                        }}
                        className="fa-regular fa-eye"
                        onClick={(e) => PasswordManager(e)}
                      />
                    </div>
                    <p
                      className="mx-3 my-2"
                      style={{ fontWeight: "700", fontSize: "13px" }}
                    >
                      {t("Note: Username and Password are Case Sensitive")}
                    </p>
                  </div>

                  {/* <div style={{ marginTop: '5px' }}>
                      <label htmlFor="captchaText" style={{ fontWeight: 'bold', fontSize: '14px' }}>Captcha</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                        <div
                          id="captcha"
                          style={{
                            backgroundColor: '#e6e6e6',
                            padding: '8px',
                            borderRadius: '5px',
                            minWidth: '100px',
                            flex: 1
                          }}
                        ></div>
                        <i className="fa fa-refresh" style={{ cursor: 'pointer' }} onClick={captchaManager}></i>
                      </div>
                      <input
                        type="text"
                        id="captchaText"
                        value={form.captchaText}
                        onChange={(e) => setform({ ...form, captchaText: e.target.value })}
                        placeholder="Enter Captcha"
                        className="form-control mt-2"
                        style={{ height: '2.5rem', backgroundColor: '#f5f5f5', border: 'none', borderRadius: '6px', paddingLeft: '10px', fontWeight: '600' }} maxLength={6}
                        required
                      />
                    </div> */}

                  <div
                    className="my-3"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "1rem",
                      marginTop: "15px",
                      flexWrap: isMobile ? "wrap" : "nowrap",
                    }}
                  >
                    <a
                      href="/ForgetPassword"
                      style={{
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontWeight: "bold",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      Forgot Password?
                    </a>
                    <div>
                      <button
                        type="submit"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "7rem",
                          height: "2.5rem",
                          background:
                            "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                          borderRadius: "11px",
                          fontSize: "19px",
                        }}
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
        <footer
          className="footer-container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            position: "absolute",
            bottom: 0,
            width: "100%",
            background:
              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
            color: "white",
            padding: "10px 20px",
            fontSize: "14px",
            alignItems: "center",
          }}
        >
          <div className="footer-text">
            <p style={{ margin: "0px" }}>
              Contents on this website are owned, updated, and managed by the
              Rural Development Department, Government of Maharashtra.
              <br />
              Site is technically designed, hosted, and maintained by{" "}
              <strong style={{ color: "#fff700" }}>
                {" "}
                Bank of Maharashtra.
              </strong>
              Site is technically designed, hosted, and maintained by{" "}
              <strong style={{ color: "#fff700" }}>
                {" "}
                Bank of Maharashtra.
              </strong>
            </p>
          </div>
          <div
            className="footer-logo-container"
            style={{ display: "flex", gap: "16px" }}
          >
            <img
              src={BankofMaharashtraLogo256}
              style={{ backgroundColor: "white", height: "auto" }}
            />
            {/* <img src={SoftmateSystemsLogo} style={{ width: '7.5rem', height: 'auto' }} /> */}
          </div>
        </footer>
      </div>

      {showOTP && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "16px",
              padding: "40px 36px",
              width: "100%",
              maxWidth: "420px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              textAlign: "center",
              fontFamily: "sans-serif",
            }}
          >
            {/* Header */}
            <div
              style={{
                background:
                  "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                borderRadius: "10px",
                padding: "14px",
                marginBottom: "24px",
              }}
            >
              <h5
                style={{
                  color: "white",
                  margin: 0,
                  fontWeight: "700",
                  fontSize: "18px",
                }}
              >
                OTP Verification
              </h5>
            </div>

            {/* Icon */}
            <div
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                background: "linear-gradient(to bottom, #0067ab, #0098d5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              <i
                className="fa-regular fa-envelope"
                style={{ color: "white", fontSize: "28px" }}
              />
            </div>

            <p
              style={{
                fontSize: "14px",
                color: "#555",
                marginBottom: "6px",
              }}
            >
              OTP has been sent to your registered mobile number
              <br />
              <strong>{maskedPhone}</strong>
            </p>
            <p
              style={{ fontSize: "13px", color: "#888", marginBottom: "24px" }}
            >
              This OTP is valid for{" "}
              <strong style={{ color: "#e53935" }}>2 minutes</strong>
            </p>

            {/* OTP Input */}
            <div style={{ position: "relative", marginBottom: "20px" }}>
              <img
                src={Password32}
                alt="otp"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "20px",
                  height: "20px",
                }}
              />
              <input
                type="text"
                value={otp}
                maxLength={6}
                placeholder="Enter 6-digit OTP"
                onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
                style={{
                  width: "100%",
                  height: "48px",
                  border: "2px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "0 16px 0 44px",
                  fontSize: "18px",
                  fontWeight: "700",
                  letterSpacing: "6px",
                  textAlign: "center",
                  outline: "none",
                  backgroundColor: "#f5f5f5",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#0067ab")}
                onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
              />
            </div>

            {/* Verify Button */}
            <button
              onClick={VerifyOTP}
              disabled={otp.length !== 6}
              style={{
                width: "100%",
                height: "48px",
                background:
                  otp.length === 6
                    ? "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)"
                    : "linear-gradient(to right, #aaa, #ccc)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "700",
                cursor: otp.length === 6 ? "pointer" : "not-allowed",
                marginBottom: "16px",
                transition: "opacity 0.2s",
              }}
            >
              Verify OTP
            </button>

            {/* Resend / Cancel */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => {
                  setShowOTP(false);
                  setOtp("");
                }}
                style={{
                  background: "none",
                  border: "none",
                  color: "#e53935",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                Cancel
              </button>
              <button
                onClick={resendOTP}
                disabled={!canResend}
                style={{
                  background: "none",
                  border: "none",
                  color: canResend ? "#0067ab" : "#999",
                  cursor: canResend ? "pointer" : "not-allowed",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                {canResend ? "Resend OTP" : `Resend OTP (${resendTimer}s)`}
              </button>
            </div>

            <p style={{ fontSize: "11px", color: "#aaa", marginTop: "16px" }}>
              Do not share this OTP with anyone
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLogin;
